import { COLOR_LINK } from 'constants/colors';
import styled from 'styled-components';
import { Descriptions } from 'UI';

export const OrderDescriptions = styled(Descriptions)`
  width: 100%;
`;

export const ActionButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  padding: 0;

  &:hover {
    text-decoration: underline;
    background: transparent;
    color: ${COLOR_LINK};
  }

  &:active, &:focus {
    background: transparent;
    color: ${COLOR_LINK};
  }

  &.ant-btn:not([disabled]):hover {
    text-decoration: underline;
  }
`;

export const TextHighlight = styled.span`
  // font-weight: bold;
`;
